<div class="banner">
  <span>订单确认 {{ busSeatID > 0 ? "(续费)" : "" }}</span>
</div>
<mat-icon class="close" mat-dialog-close>close</mat-icon>
<div class="platform-info">
  <app-image [fileid]="busTypePlatform?.icon" [radius]="8"></app-image>

  <div class="name">
    <h1>{{ busTypePlatform?.name }}</h1>

    <div class="price">
      <span class="rmb">￥</span>
      <span class="price">
        {{ totalPrice }}
      </span>
    </div>
  </div>
</div>
<div class="divider"></div>

<div class="list">
  <ng-container
    *ngIf="
      busType.username_submit ||
      busType.password_submit ||
      busType.backup_code_one ||
      busType.backup_code_two ||
      busType.region_submit
    "
  >
    <ng-container *ngIf="busType.username_submit">
      <div class="item">
        <span class="title">邮箱</span>
        <div class="content">
          <input
            class="option"
            [(ngModel)]="username"
            spellcheck="false"
            [placeholder]="
              '请输入您的邮箱' +
              (busType.username_submit === 'Optional' ? ' (选填)' : '')
            "
          />
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="busType.password_submit">
      <div class="item">
        <span class="title">密码</span>
        <div class="content">
          <input
            class="option"
            [(ngModel)]="password"
            spellcheck="false"
            [placeholder]="
              '请输入您的密码' +
              (busType.password_submit === 'Optional' ? ' (选填)' : '')
            "
          />
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="busType.backup_code_one">
      <div class="item">
        <span class="title"
          >备用安全码1<img
            src="../../../assets/images/Icon-question.svg"
            [width]="18"
            [height]="18"
            alt=""
            (click)="openLink()"
        /></span>
        <div class="content">
          <input
            class="option"
            [(ngModel)]="backup_code_one"
            spellcheck="false"
            [placeholder]="
              '请输入' +
              (busType.backup_code_one === 'Optional' ? ' (选填)' : '')
            "
          />
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="busType.backup_code_two">
      <div class="item">
        <span class="title"
          >备用安全码2<img
            src="../../../assets/images/Icon-question.svg"
            [width]="18"
            [height]="18"
            alt=""
            (click)="openLink()"
        /></span>
        <div class="content">
          <input
            class="option"
            [(ngModel)]="backup_code_two"
            spellcheck="false"
            [placeholder]="
              '请输入' +
              (busType.backup_code_two === 'Optional' ? ' (选填)' : '')
            "
          />
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="busType.region_submit">
      <div class="item">
        <span class="title">地区</span>
        <div class="content">
          <input
            class="option"
            [(ngModel)]="region_submit"
            spellcheck="false"
            [placeholder]="
              '请输入' + (busType.region_submit === 'Optional' ? ' (选填)' : '')
            "
          />
        </div>
      </div>
    </ng-container>
    <div class="divider"></div>
  </ng-container>

  <!-- <div class="item">
    <span class="title">{{ platform.duration_display || "时长" }}</span>
    <div class="content">
      <span> {{ busType.name }} </span>
    </div>
  </div>
  <ng-container *ngIf="busType.group">
    <div class="item">
      <span class="title">{{ platform.group_display || "类型" }}</span>
      <div class="content">
        <span> {{ busType.group || "默认" }} </span>
      </div>
    </div>
  </ng-container> -->
  <!-- <ng-container
    *ngIf="
      platform.seat_display !== '--' &&
      !(
        busType.delivery_method === 'User' || busType.delivery_method === 'None'
      )
    "
  >
    <div class="item">
      <span class="title">{{ platform.seat_display || "车位" }}</span>
      <div class="content">
        <span> {{ exclusive ? "包车" : "拼车" }} </span>
      </div>
    </div>
  </ng-container> -->
  <div class="item" *ngFor="let item of display_label">
    <span class="title">{{ item.group_name }}</span>
    <div class="content">
      <span> {{ busType.group_values[item.id] }} </span>
    </div>
  </div>
  <div class="item">
    <span class="title">售价</span>
    <div class="content">￥{{ totalPrice | number }}</div>
  </div>

  <ng-container *ngIf="affiliate?.wallet_balance > 0">
    <div class="item">
      <span class="title grey">可用余额</span>
      <div class="content grey">￥{{ affiliate?.wallet_balance | number }}</div>
    </div>
    <div class="item">
      <span class="title grey">使用余额</span>
      <div class="content grey">
        <input
          class="number"
          [(ngModel)]="payScore"
          (ngModelChange)="payScore = +payScore"
        />
      </div>
    </div>
  </ng-container>

  <div class="item">
    <span class="title">优惠码</span>
    <div class="content">
      <input
        type="text"
        style="text-align: right"
        [(ngModel)]="couponCode"
        placeholder="请填写优惠码"
        (keyup.enter)="onCouponCodeConfirm()"
      />
      <button
        color="primary"
        (click)="onCouponCodeConfirm()"
        style="
          border: none;
          outline: none;
          cursor: pointer;
          background: #009688;
          border-radius: 8px;
          border: 1px solid #009688;
          padding: 5px 15px;
          margin-left: 10px;
          color: #ffffff;
        "
      >
        确定
      </button>
    </div>
  </div>

  <div class="item" *ngIf="getCouponValue() !== 0">
    <span class="title">优惠金额</span>
    <div class="content">-￥{{ getCouponValue() | number }}</div>
  </div>

  <div class="item">
    <span class="title">总价</span>
    <div class="content total">
      ￥{{ totalPrice - getCouponValue() - payScore | number }}
    </div>
  </div>
</div>

<div class="extra-info">
  <p *ngIf="busType?.condition">使用条件:{{ busType.condition }}</p>
  <p #conditionText>
    售前提示：<span>{{ platform.pre_sale_tip }}</span>
  </p>
  <p #conditionText>
    售后说明：<span>{{ platform.after_sale_tip }}</span>
  </p>
  <p *ngIf="busTypePlatform?.name === '借个号'" class="renew">
    <img src="../../../assets/images/jiegehao/img.png" alt="" />
    续费推荐：续费会员推荐前往<span (click)="goto('https://jiegehao.cn')"
      >借个号官网</span
    >，福利更多，优惠力度更大
  </p>
</div>

<div class="agreement">
  <mat-checkbox [(ngModel)]="agree">
    我已阅读并同意<a
      routerLink="/agreement"
      style="color: #009688; text-decoration: none"
    >
      《用户协议》 </a
    >， 确认知悉
    <span (click)="triggerFlashAll()"> 商品售前、售后 </span
    >以及退款政策等相关事项。
  </mat-checkbox>
</div>

<div class="pay-methods">
  <div class="pm-title">支付方式</div>
  <div class="pm-row">
    <div class="pm-method">
      <span class="pm-label">Waffo</span>
    </div>
  </div>
</div>

<div class="button">
  <button
    mat-raised-button
    color="primary"
    class="purchase"
    (click)="pay()"
  >
    立即支付
  </button>
</div>
